import React from "react";
import styled from "styled-components";
import img1 from "../images/mgt2.jpeg";
import img2 from "../images/mgt1.jpg";
import img3 from "../images/mgt3.jpeg";

import bkgroundimg from "../images/mgtbackground.jpeg";
function Mgteam() {
  return (
    <MgteamCon>
      <div className="bkgpic_msg">
        <div className="message">The Management Team</div>
      </div>
      <a className="globalhome" href="/">
        Global Home{" "}
      </a>
      | Futurebreakgh Management Team.
      <div className="imgandesc">
        <div className="image-container">
          <img className="image" src={img1} alt=" " />
        </div>
        <div className="desc-container">
          Mr. Simone Obeng: As the CEO of Futurebreakgh Freight Services, it is
          my privilege to welcome you to our esteemed network of clients,
          partners, and team members who are dedicated to revolutionizing the
          logistics industry.
        </div>

        <div className="desc-container">
          Mr. Jack Obeng: We eagerly anticipate the opportunity to serve you and
          to be a trusted partner in your global trade endeavors.
        </div>
        <div className="image-container">
          <img className="image" src={img2} alt=" " />
        </div>
        <div className="image-container">
          <img className="image" src={img3} alt=" " />
        </div>
        <div className="desc-container">
          Mrs Dimond Obeng: Thank you for selecting Noble Shipping as your
          reliable freight forwarding partner. We eagerly anticipate continuing
          our successful partnership and reaching new milestones in service
          excellence together.
        </div>
      </div>
    </MgteamCon>
  );
}

export default Mgteam;

const MgteamCon = styled.div`
  width: 75vw;
  margin-left: calc((100vw - 75vw) / 2);
  margin-right: calc((100vw - 75vw) / 2);

  .bkgpic_msg {
    background-image: url(${bkgroundimg});
    background-repeat: no-repeat;
    background-position: center; /* Center the background image */
    background-size: cover; /* Ensure the image covers the entire div */
    height: 30vh;
    display: flex; /* Use flexbox to center the text inside */
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    position: relative; /* Allow positioning of text elements over the image */
  }

  .message {
    font-weight: bold;

    font-size: 50px;
  }
  .globalhome {
    padding-bottom: 20px;
  }

  .imgandesc {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    justify-content: center;
    margin-top: 50px;
    gap: 30px;
  }
  .image-container .image {
    width: 10vw;
    height: 20vh;
    border-radius: 50%;
    border: 2px solid gainsboro;
    align-items: center;.
       justify-content: center;

  }

  .imgandesc .desc-container {
    padding: 20px;

    text-align: justify;
  }

  @media (max-width: 700px) {
    width: 100vw;

    .imgandesc {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      justify-content: center;
      margin-top: 50px;
      gap: 30px;
      margin-left: -85px;
      padding-left: 5px;
      padding-right: 15px;
    }
    .image-container .image {
      width: 100vw;
      height: 30vh;
      justify-content: center;
      align-items: center;
      border-radius: 0px 200px 200px 0px;
    }
    .desc-containe {
      width: 100%;
    }
    .bkgpic_msg {
      margin-left: -65px;
    }
  }
`;
